import Select from "react-select";

const ReactSelect = ({
  options,
  contentType,
  name,
  handleContentChange,
  id,
  isMulti,
  placeholder,

  isSearchable,
  isClearable = false,
  disabled = false,
  versionData = null,
  selectedValue = null,
}) => {
  return (
    <>
      {versionData ? (
        <Select
          isDisabled={true}
          value={versionData}
          className="mb-2 border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          options={options}
          isSearchable={isSearchable}
          isMulti={isMulti}
          isClearable
          placeholder={placeholder}
          onChange={(event: any) => handleContentChange(name, event)}
          id={id}
        />
      ) : null}
      <Select
        isDisabled={disabled}
        value={contentType}
        className="mb-2 border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        options={options}
        isSearchable={isSearchable}
        isMulti={isMulti}
        isClearable
        placeholder={placeholder}
        // defaultValue={failedStatus[0]}
        onChange={(event: any) => handleContentChange(name, event)}
        id={id}
      />
    </>
  );
};

export default ReactSelect;
